import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { rSorgulamaSonuclari } from '../../models/.catalog';
import rList from '../../models/rList';
import pSorgulamaSonuclari from '../../models/pSorgulamaSonuclari';

export default class SorgulamaSonuclariApi extends ApiBase<pSorgulamaSonuclari, rList<rSorgulamaSonuclari>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/ListeleHiyerarsik',
      }),
      options
    );
  }
}
